module.exports = require("velocity-animate");


//////////////////
// WEBPACK FOOTER
// external "velocity-animate"
// module id = 49
// module chunks = 0